"use client";

import { useEffect } from "react";

/**
 * Images that are still loading when the page hydrates fade in once. Images already on screen are left alone, the
 * server HTML never hides anything, and reduced motion skips it entirely.
 */
export function FadeImages() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    for (const image of document.querySelectorAll<HTMLImageElement>(".hf img[data-fade]")) {
      if (image.complete) continue;
      image.classList.add("is-fading");
      const done = () => image.classList.add("is-in");
      image.addEventListener("load", done, { once: true });
      image.addEventListener("error", done, { once: true });
    }
  }, []);
  return null;
}
